import { render, staticRenderFns } from "./Product.view.vue?vue&type=template&id=52ac0e6e&"
import script from "./Product.view.vue?vue&type=script&lang=js&"
export * from "./Product.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports